export default "__VITE_ASSET__nvM$Ixpk__"